
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import { InsurancePassenger } from "@/models/www/Insurance";
import { InsurancePassengerState } from "@/models/www/store/InsuranceState";
import { useInsuranceStore } from "@/store/insurance";
import { computed, defineComponent, PropType } from "vue";

export default defineComponent({
	components: {
		BaseCheckbox
	},
	props: {
		index: Number,
		passenger: {
			type: Object as PropType<InsurancePassenger>,
			required: true
		}
	},
	setup(props) {
		const insuranceStore = useInsuranceStore();

		const passengerInput = computed({
			get(): boolean {
				return insuranceStore.getPassengers.filter(p => p.id === props.passenger.id).length > 0;
			},
			set(value: boolean) {
				if(value) {
					insuranceStore.addPassenger({
						...props.passenger
					} as InsurancePassengerState);
				}
				else {
					insuranceStore.removePassenger(props.passenger.id);
				}
			}
		});

		return { passengerInput }
	}
});
